<div class="row mb-4 p-2">
    <div class="col-12 mt-2 p-0 mb-4" *ngIf="searchResult">
        <ng-container *ngIf="showNoContent && searchInput.length > 0">
        </ng-container>
    </div>

    <!-- Invite/Create Beneficiary Details-->
    <div class="col-12 mt-3 p-0">
        <h6 class="mb-2">Enter the details of <b>maximum 3 Beneficiaries</b> who will be using the Imagility during free trial.
        </h6>
        <div class="warning-msg">
            <i class="fa fa-warning"></i>
            The added beneficiaries will be added and linked with the petitioner you added in the previous step. The invite will be sent on behalf of the petitioner.
          </div>
        
        <!--Choose Invite/Create Beneficiary-->

        <div class="row mt-3" *ngIf="this.userCompanyFirmInfo.length === 1;else getFamilyBased">
            <div class="p-field-radiobutton pr-5">
                <p-radioButton [disabled]="disableFields || this.empRadioBtn" name="immigrationType" value="Employment" (click)="chooseType()" [(ngModel)]="immigrationType" inputId="city1">
                </p-radioButton>
                <label class="radBtn" for="city1">Employment based </label>
            </div>
            <div class="p-field-radiobutton">
                <p-radioButton [disabled]="disableFields || this.familyRadioBtn" name="immegrationType" value="Family" (click)="chooseType()" [(ngModel)]="immigrationType" inputId="city2">
                </p-radioButton>
                <label class="radBtn" for="city2">Family based</label>
            </div>
        </div>
        <ng-template #getFamilyBased>
            <div class="row mt-3">
                <div class="p-field-radiobutton">
                    <p-radioButton [disabled]="disableFields || this.familyRadioBtn" name="immegrationType" value="Family" (click)="chooseType()" [(ngModel)]="immigrationType" inputId="city2">
                    </p-radioButton>
                    <label class="radBtn" for="city2">Family based</label>
                </div>
            </div>
        </ng-template>
       

        <div class="col-sm-12 mt-2 mb-3 p-0">
            <!--Send Invite-->
           
                <form [formGroup]="inviteExternalBeneForm" #inviteBene="ngForm"
                    (ngSubmit)="inviteExternalBeneFormSub()">
                    <div *ngIf="this.userCompanyFirmInfo.length === 1;else getFamilyBasedForm">
                         <div>

                  <ng-container *ngIf="immigrationType === 'Employment'">
                    <div class="info-msg">
                        <i class="fa fa-info-circle"></i>
                        Employment based is for beneficiary of client company.
                      </div>
                    <div class="form-row">
                        <div class="form-group col-md-4 pr-5">
                            <div class="p-field">
                                <label class="required" for="firstName">First Name</label>
                                <input [disabled]="disableFields" id="firstName" type="text" pInputText formControlName="firstName"
                                    [ngClass]="{ 'im-input-error': (f1.firstName.touched || isSubmitted) && f1.firstName.errors  }" />
                            </div>
                        </div>
                        <div class="form-group col-md-4 pr-5">
                            <div class="p-field">
                                <label class="required" for="lastName">Last Name</label>
                                <input [disabled]="disableFields" id="lastName" type="text" pInputText formControlName="lastName"
                                    [ngClass]="{ 'im-input-error': (f1.lastName.touched || isSubmitted) && f1.lastName.errors  }" />
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <div class="p-field">
                                <label for="middleName">Middle Name<small> (Optional)</small></label>
                                <input [disabled]="disableFields" id="middleName" type="text" pInputText formControlName="middleName" />
                            </div>
                        </div>
                        <div class="form-group col-md-4 pr-5">
                            <div class="p-field">
                                <label class="required" for="userId">User ID</label>
                                <input [disabled]="disableFields" id="userId" type="text" pInputText formControlName="userId"
                                    [ngClass]="{ 'im-input-error': (f1.userId.touched || isSubmitted) && f1.userId.errors  }" />
                            </div>
                        </div>
                        <div class="form-group col-md-4 pr-5">
                            <div class="p-field">
                                <label class="required" for="communicationEmailId">Email Id</label>
                                <input [disabled]="disableFields" id="communicationEmailId" type="text" pInputText pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$"
                                    formControlName="communicationEmailId"
                                    [ngClass]="{ 'im-input-error': (f1.communicationEmailId.touched || isSubmitted) && f1.communicationEmailId.errors  }" />
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

                <ng-container *ngIf="immigrationType === 'Family'"> 
                    <div class="info-msg">
                        <i class="fa fa-info-circle"></i>
                        Family based is for individual beneficiary.
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-4 pr-5">
                            <div class="p-field">
                                <label class="required" for="firstName">First Name</label>
                                <input [disabled]="disableFields" id="firstName" type="text" pInputText formControlName="firstName"
                                    [ngClass]="{ 'im-input-error': (f1.firstName.touched || isSubmitted) && f1.firstName.errors  }" />
                            </div>
                        </div>
                        <div class="form-group col-md-4 pr-5">
                            <div class="p-field">
                                <label class="required" for="lastName">Last Name</label>
                                <input [disabled]="disableFields" id="lastName" type="text" pInputText formControlName="lastName"
                                    [ngClass]="{ 'im-input-error': (f1.lastName.touched || isSubmitted) && f1.lastName.errors  }" />
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <div class="p-field">
                                <label for="middleName">Middle Name<small> (Optional)</small></label>
                                <input [disabled]="disableFields" id="middleName" type="text" pInputText formControlName="middleName" />
                            </div>
                        </div>
                        <div class="form-group col-md-4 pr-5" *ngIf="showMyContainer">
                            <div class="p-field">
                                <label class="required" for="userId">User ID</label>
                                <input id="userId" type="text" pInputText formControlName="userId"
                                    />
                            </div>
                        </div>
                        <div class="form-group col-md-4 pr-5">
                            <div class="p-field">
                                <label class="required" for="communicationEmailId">Email Id</label>
                                <input [disabled]="disableFields" id="communicationEmailId" type="text" pInputText pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$"
                                    formControlName="communicationEmailId"
                                    [ngClass]="{ 'im-input-error': (f1.communicationEmailId.touched || isSubmitted) && f1.communicationEmailId.errors  }" />
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <ng-template #getFamilyBasedForm>
                <div>
                    <ng-container *ngIf="immigrationType === 'Family'"> 
                        <div class="info-msg">
                            <i class="fa fa-info-circle"></i>
                            Family based is for individual beneficiary.
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4 pr-5">
                                <div class="p-field">
                                    <label class="required" for="firstName">First Name</label>
                                    <input [disabled]="disableFields" id="firstName" type="text" pInputText formControlName="firstName"
                                        [ngClass]="{ 'im-input-error': (f1.firstName.touched || isSubmitted) && f1.firstName.errors  }" />
                                </div>
                            </div>
                            <div class="form-group col-md-4 pr-5">
                                <div class="p-field">
                                    <label class="required" for="lastName">Last Name</label>
                                    <input [disabled]="disableFields" id="lastName" type="text" pInputText formControlName="lastName"
                                        [ngClass]="{ 'im-input-error': (f1.lastName.touched || isSubmitted) && f1.lastName.errors  }" />
                                </div>
                            </div>
                            <div class="form-group col-md-4">
                                <div class="p-field">
                                    <label for="middleName">Middle Name<small> (Optional)</small></label>
                                    <input [disabled]="disableFields" id="middleName" type="text" pInputText formControlName="middleName" />
                                </div>
                            </div>
                            <div class="form-group col-md-4 pr-5" *ngIf="showMyContainer">
                                <div class="p-field">
                                    <label class="required" for="userId">User ID</label>
                                    <input id="userId" type="text" pInputText formControlName="userId"
                                        />
                                </div>
                            </div>
                            <div class="form-group col-md-4 pr-5">
                                <div class="p-field">
                                    <label class="required" for="communicationEmailId">Email Id</label>
                                    <input [disabled]="disableFields" id="communicationEmailId" type="text" pInputText pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$"
                                        formControlName="communicationEmailId"
                                        [ngClass]="{ 'im-input-error': (f1.communicationEmailId.touched || isSubmitted) && f1.communicationEmailId.errors  }" />
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-template>

        <div *ngIf="this.orgeditBtnInviteBene">
            <button *ngIf="immigrationType === 'Employment'" type="submit" class="im-btn im-btn-primary im-btn-md p-2"
                [disabled]="inviteExternalBeneForm.invalid || inviteExternalBeneForm.disabled ">
                <i class="fa fa-plus-circle"></i> Add to Invite List
            </button><br>
            <button *ngIf="immigrationType === 'Family'" type="submit" class="im-btn im-btn-primary im-btn-md p-2"
                [disabled]="f1.firstName.invalid|| f1.lastName.invalid || f1.communicationEmailId.invalid || f1.firstName.disabled|| f1.lastName.disabled || f1.communicationEmailId.disabled " >
                <i class="fa fa-plus-circle"></i> Add to Invite List
            </button><br>
        </div>
         <button *ngIf="this.editBtnInviteBene && immigrationType === 'Employment'" type="button" 
            (click)="updateInvitelist()" [disabled]="inviteExternalBeneForm.invalid || inviteExternalBeneForm.disabled "
            class="im-btn im-btn-primary im-btn-md p-2">
            <i class="fa fa-plus-circle"></i> Add to Invite List
         </button><br>

         <button *ngIf="this.editBtnInviteBene && immigrationType === 'Family'" type="button" 
            (click)="updateInvitelist()" 
            [disabled]="f1.firstName.invalid|| f1.lastName.invalid || f1.communicationEmailId.invalid || f1.firstName.disabled|| f1.lastName.disabled || f1.communicationEmailId.disabled "
            class="im-btn im-btn-primary im-btn-md p-2">
            <i class="fa fa-plus-circle"></i> Add to Invite List
        </button><br>

                    <span class="invite-info pt-2"><i class="fa fa-info-circle"></i> Invitations will be sent only after you finish all the step.</span>
                </form>
        </div>
        <!--EOD Choose Invite/Create Beneficiary-->
    </div>
    <!--EOD Beneficiary Details-->
    <p-dialog header="Invite Beneficiaries" [(visible)]="displayBasic" [style]="{width: '25vw'}">
        <p>You can invite upto Maximum 3 Beneficiaries </p>
    </p-dialog>
    <span class="dashed-divider"></span>

    <!--Invite Sent Beneficiary Details-->
    <div class="col-sm-12 mt-3 mb-5 p-0">
        <span class="mb-1"><h6>Invite Sent Details</h6></span>
        <p-table [responsive]="true" [value]="inviteSent">
            <ng-template pTemplate="header">
                <tr>
                    <th>Immigration Type</th>
                    <th>Name</th>
                    <th>User ID</th>
                    <th>Communication Email</th>
                    <th>Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-inviteSent let-i="rowIndex">
                <tr>
                    <td>{{inviteSent.immigrationType}}</td>
                    <td>{{inviteSent.firstName}} {{inviteSent.lastName}}</td>
                    <td *ngIf="inviteSent.userId; else noUserid">{{inviteSent.userId }}</td>
                    <ng-template #noUserid>
                    <td>N.A</td>
                    </ng-template>
                    <td>{{inviteSent.emailId}}</td>
                    <td>
                        <div class="ml-2">
                            <span class="ml-2 mr-2"><mat-icon class="mr-1 icn"
                              matTooltip="Edit"  (click)="editNewsendinvite(inviteSent, i)"
                              class="material-icons">edit</mat-icon></span>
                            <span  (click)="deleteImmigration(inviteSent)">
                              <mat-icon 
                                class="mr-1 icn"
                                matTooltip="Delete"
                                class="material-icons"
                                >delete</mat-icon
                              >
                            </span>                            
                          </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-inviteSent>
                <tr>
                    <td [attr.colspan]="4">
                        No records found
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="row">
    <div class="col-6"></div>
    <div class="col text-right">
      <button (click)="onCancel()" pButton type="button" class="align-top mr-4 p-button-secondary">
        Cancel
      </button>
      <div class="border-right d-inline-block mr-4" style="height:46px"></div>
      <button (click)="onPrevious()" class="im-btn im-btn-primary im-btn-md mr-2" [disabled]="">
        Previous
      </button>
      <button (click)="onNext()" class="im-btn im-btn-primary im-btn-md"> Next </button>
    </div>
</div>
  <p-confirmDialog header="Delete"></p-confirmDialog>